import styled from "styled-components";

interface FieldElementProps {
  height: number;
}

export const FieldElement = styled.div<FieldElementProps>`
  display: flex;
  flex-direction: column;
  height: ${(props) => (props.height ? `${props.height}px` : "54px")};
  margin-bottom: 15px;

  width: 100%;
`;
